import ViewAppointmentDialog from "./ViewAppointmentDialog";

export default ViewAppointmentDialog;